import { Component, EventEmitter, Input, Output, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatLegacySlideToggleChange, MatLegacySlideToggleModule } from '@angular/material/legacy-slide-toggle';

@Component({
  selector: 'ptl-sg-toggle',
  standalone: true,
  imports: [MatLegacySlideToggleModule],
  templateUrl: './sg-toggle.component.html',
  styleUrls: ['./sg-toggle.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SgToggleComponent),
      multi: true,
    },
  ],
})
export class SgToggleComponent implements ControlValueAccessor {
  @Input() disabled = false;
  @Input() checked = false;
  @Input() size: 'small' | 'medium' = 'medium';
  @Input() labelPosition: 'before' | 'after' = 'after';
  @Input() waitingList = false;
  @Input() ariaLabel: string;

  @Output() toggleChange = new EventEmitter<MatLegacySlideToggleChange>();

  private onChange = (value: boolean) => {
    // ControlValueAccessor callback
  };
  private onTouched = () => {
    // ControlValueAccessor callback
  };

  // ControlValueAccessor implementation
  writeValue(value: boolean): void {
    this.checked = value || false;
  }

  registerOnChange(fn: (value: boolean) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onToggle(event: MatLegacySlideToggleChange): void {
    this.checked = event.checked;
    this.onChange(this.checked);
    this.toggleChange.emit(event);
  }

  onBlur(): void {
    this.onTouched();
  }
}
